import React from "react";
import AccountsList from "./List";

const DemoAccounts = () => {
  return (
    <AccountsList
      defaultAccountType="demo"
      hideAccountTypeSwitcher={true}
      customTitle="Demo Accounts"
    />
  );
};

export default DemoAccounts;
